var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6667C9.84085 14.6667 11.5075 13.9205 12.714 12.7141C13.9204 11.5076 14.6666 9.84097 14.6666 8.00004C14.6666 6.15911 13.9204 4.49244 12.714 3.28599C11.5075 2.07957 9.84085 1.33337 7.99992 1.33337C6.15899 1.33337 4.49232 2.07957 3.28587 3.28599C2.07945 4.49244 1.33325 6.15911 1.33325 8.00004C1.33325 9.84097 2.07945 11.5076 3.28587 12.7141C4.49232 13.9205 6.15899 14.6667 7.99992 14.6667Z",
    fill: "white",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 3.66663C8.46031 3.66663 8.83341 4.03973 8.83341 4.49996C8.83341 4.96019 8.46031 5.33329 8.00008 5.33329C7.53985 5.33329 7.16675 4.96019 7.16675 4.49996C7.16675 4.03973 7.53985 3.66663 8.00008 3.66663Z",
    fill: "#2A3D4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 11.3333V6.66663H7.83333H7.5",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.3334H9.33333",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationBlack);
export default __webpack_public_path__ + "static/media/information-black.cc38be0da073b2c37e0773b2b486f632.svg";
export { ForwardRef as ReactComponent };